require('angular');		
require('angular-sanitize');
require('./videogular');

module.exports = 'com.2fdevs.videogular';
